
// TODO: add all statuses
export enum UvamStatus {
    None = 'None',
    Open = 'Open',
    Rejected = 'Rejected',
  }